module.exports = __webpack_public_path__ + "static/media/blog-2.20bc6fce.jpeg";